export default __webpack_public_path__ + "static/media/TSL_Logo.a55ccbd3.svg";